import notification from 'ant-design-vue/es/notification'
import 'ant-design-vue/es/notification/style'

let notificationKey = 1;

const NotificationMaker = (type = 'info') => {
  if (!notification[type]) {
    throw new Error(`Notification of ${type} is not defined`)
  }

  return (
    options = {
      message: '',
      description: '',
      duration: 3,
      placement: 'topRight',
      onClose: null,
      key: notificationKey++
    }
  ) => {
    const globalOptions = {
      ...options
    };

    // Add `role="alert"` to the notification container after rendering
    setTimeout(() => {
      const notificationElement = document.querySelector(
        `.ant-notification span`
      )
      if (notificationElement) {
        notificationElement.setAttribute('role', 'alert')
      }
    }, 0) // Ensure DOM is updated before adding `role`

    return notification[type](globalOptions)
  };
};

// export { notification };

export default NotificationMaker;
